<div class="flex flex-col flex-1-0-100">
  <div class="modal-header flex flex-row justify-between items-center">
    <h1>Orbitax Analytics</h1>
  </div>

  <mat-dialog-content class="flex flex-col justify-start items-start">
    <div>
      <img src="https://s3-us-west-2.amazonaws.com/orbitaxservices.com/orbitax-assets/images/orbitax-images/analyis-modal.png" alt="Orbitax Analytics">
      <p class="fn-s-13">
        The Orbitax Analytics tool provides you with a series of visual charts, offering an overview of various data
        elements being maintained in ITP, for example your countries or entities that have tax law changes that will
        become
        effective in the next month, countries or entities in the EMEA region with various compliance due dates for the
        next
        quarter.
      </p>
      <p fn-s-13>
        The Analytics tool is completely customizable both in terms of the data that can be viewed as well as the type of
        visual display to use. Custom reports can be created and saved for reference or sent to stakeholders at scheduled
        frequencies.
      </p>
      <p>
        <strong>
          To get the most out of the Analytics feature, you should provide your global footprint, including entity and
          transaction data via the Project Settings (or simply select countries from the settings panel in either Change
          Reports Tracker or International Tax Research & Compliance Expert).
        </strong>
      </p>
    </div>

  </mat-dialog-content>

  <div class="m-t-10 flex flex-row">
    <button mat-flat-button class="request-demo m-r-20" type="button"
            particleAnalytics (click)="closeDialog()"
            analyticsCategory="analytics-entry-dialogue"
            analyticsAction="get-started-btn">
      Get Started <i class="far fa-long-arrow-right"></i>
    </button>

    <button mat-stroked-button class="find-out-more-btn" type="button"
            particleAnalytics
            (click)="redirectToProjectSettings()"
            analyticsCategory="analytics-entry-dialogue"
            analyticsAction="project-Settings-btn">
      Project Settings
    </button>
  </div>
</div>

